<template>
  <v-container fluid id="diferencial" class="diferencial-section pa-12">
    <v-container class="pa-10">

      <!-- CABEÇALHO -->
      <v-row justify="center">
        <v-col cols="12" md="9" class="text-center">
          <div class="diferencial-label">POR QUE ESCOLHER</div>
          <h2 class="diferencial-title">
            O sistema feito para<br>
            <span class="highlight">quem vive o transporte</span>
          </h2>
          <p class="diferencial-subtitle">
            Menos ligação, menos planilha, menos dor de cabeça. O sistema que fala
            a língua do motorista e entrega controle total para o gestor.
          </p>
        </v-col>
      </v-row>

      <!-- CARDS PRINCIPAIS -->
      <v-row justify="center" class="mt-10">

        <!-- CARD 1: Despesas pelo WhatsApp -->
        <v-col cols="12" md="6" lg="3" class="mb-6">
          <div class="dif-card">
            <div class="dif-card-icon-wrap green-glow">
              <v-icon color="#10b981" size="32">mdi-whatsapp</v-icon>
            </div>
            <div class="dif-card-title">Despesas pelo WhatsApp</div>
            <div class="dif-card-desc">
              O motorista manda a despesa direto pelo WhatsApp e ela já cai no sistema
              na hora — sem papel, sem ligação, sem atraso.
            </div>
          </div>
        </v-col>

        <!-- CARD 2: Alertas de vencimento -->
        <v-col cols="12" md="6" lg="3" class="mb-6">
          <div class="dif-card">
            <div class="dif-card-icon-wrap yellow-glow">
              <v-icon color="#f59e0b" size="32">mdi-bell-ring-outline</v-icon>
            </div>
            <div class="dif-card-title">Alerta 30 dias antes do vencimento</div>
            <div class="dif-card-desc">
              O sistema detecta documentos perto de vencer e avisa direto no WhatsApp
              com 30 dias de antecedência. Chega de multa por descuido.
            </div>
          </div>
        </v-col>

        <!-- CARD 3: Plano Base -->
        <v-col cols="12" md="6" lg="3" class="mb-6">
          <div class="dif-card">
            <div class="dif-card-icon-wrap blue-glow">
              <v-icon color="#3b82f6" size="32">mdi-truck-outline</v-icon>
            </div>
            <div class="dif-card-title">Plano Base para qualquer transportadora</div>
            <div class="dif-card-desc">
              Cadastro de motoristas, veículos, financeiro e alertas. Funciona para
              qualquer tipo de transportadora, do pequeno autônomo à frota estruturada.
            </div>
          </div>
        </v-col>

        <!-- CARD 4: Plano Personalizado -->
        <v-col cols="12" md="6" lg="3" class="mb-6">
          <div class="dif-card destaque">
            <div class="dif-card-badge">COMPLETO</div>
            <div class="dif-card-icon-wrap purple-glow">
              <v-icon color="#a78bfa" size="32">mdi-file-document-multiple-outline</v-icon>
            </div>
            <div class="dif-card-title">Plano Personalizado com CT-e e Manifesto</div>
            <div class="dif-card-desc">
              Para quem precisa de mais: lançamentos de CT-e e Manifestos integrados ao
              controle financeiro e operacional da transportadora.
            </div>
          </div>
        </v-col>

      </v-row>

      <!-- LINHA DE COMPARAÇÃO DE PLANOS -->
      <v-row justify="center" class="mt-8">
        <v-col cols="12" md="10">
          <div class="planos-compare">

            <div class="plano-col plano-base">
              <div class="plano-nome">Plano Base</div>
              <ul>
                <li><v-icon small color="#10b981">mdi-check</v-icon> Cadastro de motoristas e veículos</li>
                <li><v-icon small color="#10b981">mdi-check</v-icon> Controle financeiro</li>
                <li><v-icon small color="#10b981">mdi-check</v-icon> Alertas de vencimento via WhatsApp</li>
                <li><v-icon small color="#10b981">mdi-check</v-icon> Lançamento de despesas pelo WhatsApp</li>
                <li><v-icon small color="#10b981">mdi-check</v-icon> Dashboard operacional</li>
              </ul>
              <v-btn rounded outlined color="#10b981" class="mt-4 font-weight-bold" to="/cadastro">
                Começar agora
              </v-btn>
            </div>

            <div class="plano-col plano-personalizado">
              <div class="plano-badge-top">MAIS ESCOLHIDO</div>
              <div class="plano-nome">Plano Personalizado</div>
              <ul>
                <li><v-icon small color="#a78bfa">mdi-check</v-icon> Tudo do Plano Base</li>
                <li><v-icon small color="#a78bfa">mdi-check</v-icon> Lançamento de CT-e</li>
                <li><v-icon small color="#a78bfa">mdi-check</v-icon> Lançamento de Manifestos</li>
                <li><v-icon small color="#a78bfa">mdi-check</v-icon> Relatórios avançados</li>
                <li><v-icon small color="#a78bfa">mdi-check</v-icon> Ferramentas sob Medidas</li>
                <li><v-icon small color="#a78bfa">mdi-check</v-icon> Personalização por empresa</li>
              </ul>
              <v-btn rounded color="#a78bfa" class="mt-4 font-weight-bold white--text" to="/cadastro">
                Quero o completo
              </v-btn>
            </div>

          </div>
        </v-col>
      </v-row>

    </v-container>
  </v-container>
</template>

<script>
export default {
  name: "SecaoDiferencial"
}
</script>

<style scoped>
.diferencial-section {
  min-height: 100vh;
  display: flex;
  align-items: center;
  color: white;
}

.diferencial-label {
  color: #10b981;
  font-size: 11px;
  font-weight: bold;
  letter-spacing: 2px;
  margin-bottom: 10px;
}

.diferencial-title {
  font-size: 36px;
  font-weight: 800;
  line-height: 1.2;
  margin-bottom: 16px;
}

.highlight {
  color: #10b981;
}

.diferencial-subtitle {
  color: #94a3b8;
  font-size: 15px;
}

/* CARDS */
.dif-card {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(255, 255, 255, 0.07);
  border-radius: 16px;
  padding: 28px 22px;
  height: 100%;
  position: relative;
  transition: border-color 0.25s, box-shadow 0.25s;
}

.dif-card:hover {
  border-color: #10b981;
  box-shadow: 0 0 30px rgba(16, 185, 129, 0.12);
}

.dif-card.destaque {
  border-color: #a78bfa;
}

.dif-card.destaque:hover {
  box-shadow: 0 0 30px rgba(167, 139, 250, 0.18);
}

.dif-card-badge {
  position: absolute;
  top: -12px;
  left: 50%;
  transform: translateX(-50%);
  background: #a78bfa;
  color: #0d1117;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 1.5px;
  padding: 3px 14px;
  border-radius: 20px;
}

.dif-card-icon-wrap {
  width: 56px;
  height: 56px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}

.green-glow  { background: rgba(16, 185, 129, 0.1); }
.yellow-glow { background: rgba(245, 158, 11, 0.1); }
.blue-glow   { background: rgba(59, 130, 246, 0.1); }
.purple-glow { background: rgba(167, 139, 250, 0.1); }

.dif-card-title {
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 10px;
  color: #f1f5f9;
}

.dif-card-desc {
  font-size: 13px;
  color: #94a3b8;
  line-height: 1.6;
}

/* COMPARAÇÃO DE PLANOS */
.planos-compare {
  display: flex;
  gap: 24px;
  background: #0b1220;
  border-radius: 20px;
  padding: 36px 40px;
  flex-wrap: wrap;
}

.plano-col {
  flex: 1;
  min-width: 260px;
  padding: 24px;
  border-radius: 14px;
  position: relative;
}

.plano-base {
  background: rgba(255, 255, 255, 0.02);
  border: 1px solid rgba(16, 185, 129, 0.25);
}

.plano-personalizado {
  background: rgba(167, 139, 250, 0.05);
  border: 1px solid #a78bfa;
}

.plano-badge-top {
  position: absolute;
  top: -13px;
  left: 50%;
  transform: translateX(-50%);
  background: #a78bfa;
  color: #0d1117;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 1.5px;
  padding: 3px 14px;
  border-radius: 20px;
  white-space: nowrap;
}

.plano-nome {
  font-size: 20px;
  font-weight: 800;
  margin-bottom: 20px;
  color: #f1f5f9;
}

.plano-col ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.plano-col ul li {
  display: flex;
  align-items: center;
  gap: 8px;
  color: #cbd5e1;
  font-size: 14px;
  margin-bottom: 12px;
}
</style>
